import { SiteBrand } from "@/data/brand"
import { WDW } from "@/data/disney-wdw"
import { DataTable, type Filter } from "@/modules/DataTable"
import { LayoutMain } from "@/modules/layout/main"
import {
	type TableColumn,
	type TableSort,
	TableSortDirection,
} from "@/modules/Table"

const disneyData = WDW.generate()

const columns: TableColumn<WDW.Entry>[] = [
	{
		display: (x: WDW.Entry) => {
			return (
				<a href={x.Link} target="_blank" title={x.Title}>
					{x.Title.substring(0, 32)}
				</a>
			)
		},
		name: "Title",
		sortFunction: (a, b) => {
			return a.Title.toLowerCase().replace(/[^a-z0-9]/gi, "") >
				b.Title.toLowerCase().replace(/[^a-z0-9]/gi, "")
				? 1
				: -1
		},
	},
	{
		display: (x: WDW.Entry) => {
			return (
				<>
					<a href={`${x.Link}menus/`} target="_blank">
						Menu
					</a>
					{x.AcceptsReservation && (
						<>
							<span> - </span>
							<a
								href={`https://disneyworld.disney.go.com/dine-res/${x.Type.toLowerCase()}/${x.Slug}`}
							>
								Book
							</a>
						</>
					)}
				</>
			)
		},
		name: "",
	},
	{
		display: (x: WDW.Entry) => {
			return x.Location
		},
		name: "Location",
		sortFunction: (a, b) => {
			return a.Location.toLowerCase().replace(/[^a-z0-9]/gi, "") >
				b.Location.toLowerCase().replace(/[^a-z0-9]/gi, "")
				? 1
				: -1
		},
	},
]

const defaultSort: TableSort = {
	columnIndex: 0,
	direction: TableSortDirection.DESC,
}

const filters: Record<string, Filter<WDW.Entry>> = {
	mobile_order: {
		defaults: Object.values(["Not Available", "Available"]),
		filter: (row: WDW.Entry, selectedValues: string[]): boolean => {
			return selectedValues.includes(
				row.MobileOrder ? "Available" : "Not Available",
			)
		},
		label: "Mobile Order Available",
		options: {
			no: "Not Available",
			yes: "Available",
		},
	},
	reservation: {
		defaults: Object.values(["Accepted", "Not Accepted"]),
		filter: (row: WDW.Entry, selectedValues: string[]): boolean => {
			return selectedValues.includes(
				row.AcceptsReservation ? "Accepted" : "Not Accepted",
			)
		},
		label: "Reservations Accepted",
		options: {
			no: "Accepted",
			yes: "Not Accepted",
		},
	},
	ticket: {
		defaults: Object.values(["Required", "Not Required"]),
		filter: (row: WDW.Entry, selectedValues: string[]): boolean => {
			return selectedValues.includes(
				row.TicketRequired ? "Required" : "Not Required",
			)
		},
		label: "Location",
		options: {
			no: "Not Required",
			yes: "Required",
		},
	},
	z_location: {
		defaults: Object.values(disneyData.Locations),
		filter: (row: WDW.Entry, selectedValues: string[]): boolean => {
			return selectedValues.includes(row.Location)
		},
		label: "Location",
		options: disneyData.Locations,
	},
}

export const PageWDW = () => {
	return (
		<LayoutMain Brand={SiteBrand}>
			<h1>WDW</h1>
			<DataTable
				columns={columns}
				data={disneyData.Entries}
				defaultSort={defaultSort}
				filters={filters}
			/>
		</LayoutMain>
	)
}
